import { PlanTypes } from "~/modules/user/store/types";

// // // //

/**
 * MAP_PLAN_TO_LABEL
 * Customer-facing display label for each PlanType
 */
export const MAP_PLAN_TO_LABEL: { [key in PlanTypes]: string } = {
    [PlanTypes.FREE]: "Free",
    [PlanTypes.TRIAL_STARTER]: "Starter (Trial)",
    [PlanTypes.TRIAL_ALL_ACCESS]: "Enterprise (Trial)",
    [PlanTypes.TRIAL_DATA_DOWNLOADS]: "Pro (Trial)",
    [PlanTypes.PREMIUM_STARTER]: "Starter",
    [PlanTypes.PREMIUM_ALL_ACCESS]: "Enterprise",
    [PlanTypes.PREMIUM_DATA_DOWNLOADS]: "Pro",
    [PlanTypes.PREMIUM_ACADEMIC]: "Academic",
};

/**
 * getPlanLabel
 * Returns the customer-facing label for a PlanType, falling back to the raw value
 */
export function getPlanLabel(planType: PlanTypes): string {
    return MAP_PLAN_TO_LABEL[planType] || planType;
}
